import { render, staticRenderFns } from "./LoginFormComp.vue?vue&type=template&id=7241020a&scoped=true"
import script from "./LoginFormComp.vue?vue&type=script&lang=ts"
export * from "./LoginFormComp.vue?vue&type=script&lang=ts"
import style0 from "./LoginFormComp.vue?vue&type=style&index=0&id=7241020a&prod&lang=scss&scoped=true"
import style1 from "./LoginFormComp.vue?vue&type=style&index=1&id=7241020a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7241020a",
  null
  
)

export default component.exports